<template>
  <div class="intersetsDescribeCard contrainer-fluid">
    <b-tabs class="interestsDescribeTabs" end align="right" v-model="tabIndex" @change="test">
      <b-tab
        title="Go to interests"
        active
        title-link-class="btn btn-bumblebee btn-mid btn-tab btn-mid-info"
      >
        <Interests />
      </b-tab>
      <b-tab
        title="Go to describe yourself"
        title-link-class="btn btn-bumblebee btn-mid btn-tab btn-mid-info"
      >
        <DescribeYourself />
      </b-tab>
      <!-- <template #tabs-start>
        <li role="presentation" class="nav-item align-self-center">
          <button class="btn btn-bumblebee btn-mid btn-tab nav-link btn-mid-primary m-0"
          @click="clickSaveChanges">
           Save Changes
          </button>
        </li>
      </template> -->
    </b-tabs>
  </div>
</template>


<script>
import Interests from "./Interests.vue";
import DescribeYourself from "./DescribeYourself.vue";

export default {
  name: "MIDInterestsDescribeYourself",
  components: { Interests, DescribeYourself },
  data() {
    return {
      tabIndex: 0
    };
  },
  methods:{
    test(){
      console.log("Test")
    },
    clickSaveChanges(){
      console.log("click tab "+this.tabIndex)
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/my_irish_date/interests_describe/Index.vue